import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import SideBar from "../side-bar/side-bar";
import "./top-bar.scss";
import { useWindowSize } from "@react-hook/window-size/throttled";
import styles from './top-bar.module.scss';
import { Button } from "@mui/material";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import { useContext } from "react";
import UserPreferenceContext from "../../contexts/user-preference-context";
import { Dropdown } from '@mui/base/Dropdown';
import { Menu } from '@mui/base/Menu';
import { MenuButton } from '@mui/base/MenuButton';
import { MenuItem } from '@mui/base/MenuItem';
import { TiArrowSortedDown } from "react-icons/ti";

const TopBar = ({ setUserPreference }) => {
  const player = useRef(null);
  const [sideBarOpen, setSideBarOpen] = useState(null);
  const [timer, setTimer] = useState(null);
  const location = useLocation();

  const [width, height] = useWindowSize();

  const [playerSize, setPlayerSize] = useState("768px");

  const userPreference = useContext(UserPreferenceContext);


  useEffect(() => {
    if (player) {
      player.current.addEventListener("complete", (evt) => {
        player.current.stop();
      });
    }
  }, [player]);

  const onSideBarClick = () => {
    setSideBarOpen(!sideBarOpen);
  };

  useEffect(() => {
    if (sideBarOpen !== null) {
      clearTimeout(timer);
      player.current.setDirection(sideBarOpen ? 1 : -1);
      player.current.play();
    }

    if (sideBarOpen) {
      setTimer(
        setTimeout(() => {
          player.current.pause();
        }, 1400)
      );
    }
  }, [sideBarOpen]);

  useEffect(() => {
    if (width > 550) {
      setPlayerSize("64px");
    } else {
      setPlayerSize("54px");
    }
  }, [width]);



  return (
    <div className="topBar full-width-element app-container">
      <div className="leftSection">
        <Link className="" to="/">
          <img src="/images/logo.png" alt="logo" />
        </Link>
      </div>
      <div className="rightSection">
        <ul>
          <li className="headerSmall">
            <Link className="" to="/">Home</Link>
          </li>
          {/* <li className="headerSmall">
            <Link className="" to="/about-us">
              About Us
            </Link>
          </li> */}
          <li className="headerSmall">
            <Link className="" to="/solutions">Solutions</Link>
          </li>
          {/* <li className="headerSmall">
            <Link className="" to="/partner">Partners</Link>
          </li> */}
          <li className="headerSmall">
          <Link className="" to="/our-story">About Us</Link>

            {/* <Dropdown>
              <MenuButton>About Us <TiArrowSortedDown /> </MenuButton>
              <Menu>
                <MenuItem >                  <Link className="" to="/our-story">Our Story</Link>
                </MenuItem>
                <MenuItem >
                  <Link className="" to="/careers">Careers</Link>
                </MenuItem>
              </Menu>
            </Dropdown> */}
          </li>
          {/* <li className="headerSmall">
            <Link className="" to="/pricing">Pricing</Link>
          </li> */}
          <li className="headerSmall">
            <Link className="" to="/contact-us">Contact Us</Link>
          </li>


          {/* <li className="headerSmall">
            <Link className="" to="/blogs">Blogs</Link>
          </li>       */}
          <li className="headerSmall">

            <a href="https://calendar.app.google/jDHDYVpEYcaE3asL7" target="_blank" rel="noopener noreferrer">
              <Button className="btn btn-primary headerSmall " style={{ bordercolour: 'white', colour: 'white' }} variant="contained" endIcon={<BsFillArrowRightCircleFill />}>
                Book a demo
              </Button>
            </a>
          </li>
        </ul>

        <span className="burgerMenuButton">
          <lottie-player ref={player} onClick={onSideBarClick} src="/lottie-files/burger-json-black.json" background="transparent" speed="1.25" style={{ width: playerSize, height: playerSize }}></lottie-player>
        </span>
      </div>

      <SideBar open={sideBarOpen} setSideBarOpen={setSideBarOpen} />
    </div>
  );
};







export default TopBar;
